import { alpha, Theme } from '@mui/material';

export default {
  components: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        '&:not(.MuiMenu-root, .MuiPopover-root) .MuiBackdrop-root': {
          backdropFilter: 'blur(2px)',
          backgroundColor: alpha(theme.palette.grayBackground.A100 || '', 0.4)
        }
      })
    }
  }
};
